import type { FC } from 'react'
import sanitizeHtml from 'sanitize-html'
import type { FooterColumnLink } from '../../../types'
import styles from '../../FooterLink.module.scss'
import { Hyperlink } from '@/tools/ui'

interface FooterLinkProps {
  item: FooterColumnLink
}

export const FooterLink: FC<FooterLinkProps> = ({ item }) =>
  item && (
    <div className={styles.customLink}>
      <Hyperlink
        className={'pintxo-typography-body2'}
        href={sanitizeHtml(item.href)}
        label={item.label}
      >
        {item.label}
      </Hyperlink>
    </div>
  )
